import React from "react";
import { Mic } from "lucide-react";

export default function VoiceButton({
  testId,
  listening,
  supported,
  onStart,
  onStop,
  size = "default", // "default" | "large"
}) {
  const isLarge = size === "large";
  
  if (!supported) return null;

  return (
    <button
      data-testid={testId}
      type="button"
      onClick={listening ? onStop : onStart}
      className={`
        relative flex items-center justify-center rounded-full transition-all
        ${isLarge 
          ? "h-12 w-12" 
          : "h-9 w-9"
        }
        ${listening
          ? "bg-red-500 text-white recording-glow"
          : "bg-slate-700/50 text-slate-400 hover:bg-slate-700 hover:text-slate-200"
        }
      `}
      title={listening ? "Click to stop recording" : "Click to start voice input"}
    >
      {/* Recording pulse rings */}
      {listening && (
        <>
          <span className="absolute inset-0 rounded-full bg-red-400 recording-pulse opacity-30" />
          <span className="absolute inset-[-4px] rounded-full border-2 border-red-400 recording-pulse opacity-50" />
        </>
      )}
      
      <Mic className={`relative z-10 ${isLarge ? "h-5 w-5" : "h-4 w-4"}`} />
      
      {/* Recording indicator dot */}
      {listening && (
        <span className="absolute -right-0.5 -top-0.5 h-2.5 w-2.5 rounded-full bg-red-600 border-2 border-slate-900" />
      )}
    </button>
  );
}
